import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Button } from 'react-bootstrap';

import { logout } from 'rdx/auth';

function Header({ isLoggedIn }) {
  const dispatch = useDispatch();
  return isLoggedIn ? (
    <div>
      <Button variant="link" onClick={() => dispatch(logout())}>
        Log out
      </Button>
    </div>
  ) : null;
}

Header.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
};

export default Header;
